module.exports = __webpack_public_path__ + "static/img/avatar.a8e34a99.jpg";